module.exports = __webpack_public_path__ + "static/media/30.87473587.mp3";